import { render } from "./ForumPostDelete.vue?vue&type=template&id=73ee9476&scoped=true"
import script from "./ForumPostDelete.vue?vue&type=script&lang=js"
export * from "./ForumPostDelete.vue?vue&type=script&lang=js"

import "./ForumPostDelete.vue?vue&type=style&index=0&id=73ee9476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ee9476"]])

export default __exports__